import React, { useEffect, useState, useRef, Component } from 'react';
import { Envelope as MailIcon, PaperPlaneTilt, MagnifyingGlass, Archive, Heart, Clock, XCircle, Sparkle, Plus, HouseLine, CaretDown, Check } from '@phosphor-icons/react';
import { Button } from '../components/ui/Button';
import { Callout } from '../components/ui/Callout';
import { getSession, cn, getOffersFromSupply, getOffersForTenant, updateOfferStatus, StoredOffer, getArchiveSessions, markOfferAsSucces, finalizeAnuntExternally, ArchiveSession, getSeenSuccesIds, markSuccesSeen, getActiveProperties, markPropertyAsRented, SavedProperty, getUnconfirmedSuccesses, getSupplyArchiveCount, retractOffer, supplySlugFromEmail } from '../lib/utils';
import { RentalConfirmationCallout, UnconfirmedSuccessEntry } from '../components/dashboard/RentalConfirmationCallout';
import { ReportRentalIssueModal } from '../components/forms/ReportRentalIssueModal';
import { ConfirmDialog } from '../components/ui/ConfirmDialog';
import { PAGE_ROUTE } from '../lib/routes';
import { OfferCard, OfferData } from '../components/dashboard/OfferCard';
import { OfferEditModal } from '../components/dashboard/OfferEditModal';
import { MovedInModal } from '../components/forms/MovedInModal';
import { ArchiveSessionCard } from '../components/dashboard/ArchiveSessionCard';
import { RequestReviewModal } from '../components/forms/RequestReviewModal';
import type { OfferStatus } from '../lib/utils';
const FILTER_OPTIONS = [{
  value: 'new',
  label: 'Noi'
}, {
  value: 'saved',
  label: 'Salvate'
}, {
  value: 'postponed',
  label: 'Amânate'
}, {
  value: 'rejected',
  label: 'Respinse'
}];
// Sort helper — parses '5/7' → 0.714
function getMatchFraction(score?: string): number {
  if (!score) return -1;
  const [matched, total] = score.split('/').map(s => parseInt(s.trim(), 10));
  if (!matched || !total) return -1;
  return matched / total;
}
// Mock applications (incoming for demand role)
const MOCK_DEMAND_APPLICATIONS: OfferData[] = [{
  id: '1',
  counterpartyName: 'Ion Marinescu',
  counterpartyAvatar: 'https://i.pravatar.cc/150?img=12',
  sentDate: '9 mai 2026',
  message: 'Bună ziua! Am un apartament de 2 camere în zona Dristor, recent renovat, care cred că se potrivește perfect cu cerințele dvs. Chiria este 480 €/lună.',
  status: 'new',
  matchScore: '5/7',
  matchedFeatures: ['Wifi', 'Mobilat', 'Centrală', 'Lift', 'Aer condiționat'],
  missingFeatures: ['Parcare', 'Balcon'],
  contactEmail: 'ion.marinescu@email.ro',
  contactPhone: '+40 721 123 456',
  listingPreview: {
    image: 'https://images.unsplash.com/photo-1554995207-c18c203602cb?auto=format&fit=crop&q=80&w=400',
    title: 'Garsonieră Pacii, Sector 6 — 36 mp, mobilată',
    priceLabel: '480 €',
    locationLabel: 'Pacii, Sector 6, București',
    url: 'https://www.imobiliare.ro/oferta/garsoniera-de-inchiriat-sector-6-pacii-mobilata-36mp-275524904'
  }
}, {
  id: '4',
  counterpartyName: 'Cristian D.',
  counterpartyAvatar: 'https://i.pravatar.cc/150?img=15',
  sentDate: '7 mai 2026',
  message: 'Salut! Nu am încă anunț online, dar îți trimit câteva poze cu apartamentul meu din Băneasa. Sunt 2 camere, mobilat, 550 €/lună.',
  status: 'new',
  matchScore: '6/7',
  matchedFeatures: ['Wifi', 'Mobilat', 'Centrală', 'Parcare', 'Balcon', 'Aer condiționat'],
  missingFeatures: ['Lift'],
  contactEmail: 'cristian.d@email.ro',
  contactPhone: '+40 745 678 901',
  photos: ['https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&q=80&w=800']
}, {
  id: '2',
  counterpartyName: 'Maria Stănescu',
  counterpartyAvatar: 'https://i.pravatar.cc/150?img=5',
  sentDate: '8 mai 2026',
  message: 'Salut! Am un studio modern în Tineretului, mobilat complet. Te-ar interesa o vizionare?',
  status: 'postponed',
  matchScore: '4/7',
  matchedFeatures: ['Wifi', 'Mobilat', 'Centrală', 'Aer condiționat'],
  missingFeatures: ['Parcare', 'Lift', 'Balcon'],
  contactEmail: 'maria.s@email.ro',
  listingPreview: {
    image: 'https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&q=80&w=400',
    title: 'Studio modern Tineretului',
    priceLabel: '400 €',
    locationLabel: 'Tineretului, București',
    url: 'https://www.storia.ro/oferta/studio-modern-tineretului'
  }
}, {
  id: '3',
  counterpartyName: 'Agenția Imobiliară Nord',
  counterpartyAvatar: 'https://i.pravatar.cc/150?img=3',
  sentDate: '5 mai 2026',
  message: 'Avem mai multe proprietăți disponibile în zona Aviației care se potrivesc bugetului dvs. Vă rugăm să ne contactați pentru detalii.',
  status: 'saved',
  matchScore: '7/7',
  matchedFeatures: ['Wifi', 'Mobilat', 'Centrală', 'Parcare', 'Lift', 'Balcon', 'Aer condiționat'],
  missingFeatures: [],
  contactEmail: 'office@imobiliarenord.ro',
  contactPhone: '+40 31 123 4567',
  acceptNote: 'Sun mâine dimineață să stabilim o vizionare.',
  listingPreview: {
    image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&q=80&w=400',
    title: 'Apartament 2 camere Aviației',
    priceLabel: '600 €',
    locationLabel: 'Aviației, București',
    url: 'https://www.storia.ro/oferta/apartament-2-camere-aviatiei'
  }
}];
// Mock applications (outgoing for supply role)
const MOCK_SUPPLY_APPLICATIONS: OfferData[] = [{
  id: 's1',
  counterpartyName: 'Olivia P.',
  counterpartyAvatar: 'https://i.pravatar.cc/150?img=5',
  sentDate: '9 mai 2026',
  message: 'Bună Olivia, apartamentul meu de 3 camere din Floreasca este disponibil și cred că s-ar potrivi perfect pentru tine și pisica ta.',
  status: 'postponed',
  listingPreview: {
    image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&q=80&w=400',
    title: 'Apartament 3 camere Floreasca',
    priceLabel: '650 €',
    locationLabel: 'Floreasca, București',
    url: 'https://izio.ro/anunt/apartament-3-camere'
  }
}, {
  id: 's2',
  counterpartyName: 'Andrei P.',
  counterpartyAvatar: 'https://i.pravatar.cc/150?img=11',
  sentDate: '7 mai 2026',
  message: 'Salut Andrei! Am un studio în Cotroceni, la 5 minute de metrou. E proaspăt renovat.',
  status: 'saved',
  contactEmail: 'andrei.design@email.ro',
  contactPhone: '+40 733 444 555',
  acceptNote: 'Arată bine. Vă sun diseară pe WhatsApp.',
  listingPreview: {
    image: 'https://images.unsplash.com/photo-1502672260266-1c1e52d15461?auto=format&fit=crop&q=80&w=400',
    title: 'Studio Cotroceni',
    priceLabel: '450 €',
    locationLabel: 'Cotroceni, București',
    url: 'https://izio.ro/anunt/studio-cotroceni'
  }
}, {
  id: 's3',
  counterpartyName: 'Maria I.',
  counterpartyAvatar: 'https://i.pravatar.cc/150?img=9',
  sentDate: '10 mai 2026',
  message: 'Bună Maria, am văzut că ești în căutarea unui apartament în centru. Te invit la o vizionare.',
  status: 'rejected',
  rejectNote: 'E peste bugetul meu — caut sub 600 €.',
  listingPreview: {
    image: 'https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&q=80&w=400',
    title: 'Apartament 2 camere Centru',
    priceLabel: '650 €',
    locationLabel: 'Centru, Cluj-Napoca',
    url: 'https://izio.ro/anunt/ap-2-camere-centru'
  }
}, {
  id: 's4',
  counterpartyName: 'Mihai R.',
  counterpartyAvatar: 'https://i.pravatar.cc/150?img=33',
  sentDate: '10 mai 2026',
  message: 'Salut Mihai, am un apartament care cred că ți se potrivește perfect.',
  status: 'new',
  listingPreview: {
    image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&q=80&w=400',
    title: 'Apartament 2 camere',
    priceLabel: '500 €',
    locationLabel: 'Tineretului, București',
    url: 'https://izio.ro/anunt/ap-2-camere'
  }
}];
interface DashboardAplicariProps {
  navigate: (page: string, context?: any) => void;
}
function mapStoredToOfferData(offer: StoredOffer, isSupply: boolean): OfferData {
  const date = new Date(offer.sentAt);
  const today = new Date();
  const isToday = date.toDateString() === today.toDateString();
  const sentDate = isToday ? 'Astăzi' : date.toLocaleDateString('ro-RO', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  return {
    ...offer,
    counterpartyName: isSupply ? offer.toName : offer.fromName,
    counterpartyAvatar: isSupply ? undefined : offer.fromAvatar,
    sentDate
  };
}
export function DashboardAplicari({
  navigate
}: DashboardAplicariProps) {
  const session = getSession();
  const isSupply = session?.role === 'supply';
  if (isSupply) {
    const liveOffers = getOffersFromSupply(session?.email || '').map(o => mapStoredToOfferData(o, true));
    // Only fall back to mock fixtures when there are no live offers — this
    // avoids the seed-collision bug where Olivia's seeded offers duplicate
    // the static Ion Marinescu entries.
    const merged = liveOffers.length > 0 ? liveOffers : MOCK_SUPPLY_APPLICATIONS;
    const unique = Array.from(new Map(merged.map(item => [item.id, item])).values());
    return <ApplicationsList navigate={navigate} isSupply={true} initialData={unique} data-id="element-3319" />;
  }
  // Demand mode: default to 'olivia-p' slug if not set, to allow testing the loop
  const tenantSlug = session?.slug || 'olivia-p';
  const liveOffers = getOffersForTenant(tenantSlug).map(o => mapStoredToOfferData(o, false));
  const merged = liveOffers.length > 0 ? liveOffers : MOCK_DEMAND_APPLICATIONS;
  const unique = Array.from(new Map(merged.map(item => [item.id, item])).values());
  return <ApplicationsList navigate={navigate} isSupply={false} initialData={unique} data-id="element-3320" />;
}
// ─────────────────────────────────────────────────────────────────
// Shared Applications List Component
// ─────────────────────────────────────────────────────────────────
function ApplicationsList({
  navigate,
  isSupply,
  initialData
}: {
  navigate: (page: string, context?: any) => void;
  isSupply: boolean;
  initialData: OfferData[];
}) {
  const session = getSession();
  const tenantName = session?.name;
  const isAgent = session?.subRole === 'agent';
  const [applications, setApplications] = useState<OfferData[]>(initialData);
  const [filter, setFilter] = useState<string>('new');
  const [archiveSessions, setArchiveSessions] = useState<ArchiveSession[]>(!isSupply ? getArchiveSessions() : []);
  const [seenSuccesIds, setSeenSuccesIds] = useState<string[]>(() => isSupply ? getSeenSuccesIds() : []);
  // Supply-side: property switcher + rental closure ritual
  const [activeProperties, setActiveProperties] = useState<SavedProperty[]>(() => isSupply ? getActiveProperties(session?.email) : []);
  const [selectedPropertyId, setSelectedPropertyId] = useState<string | null>(null);
  const [propertyDropdownOpen, setPropertyDropdownOpen] = useState(false);
  const propertyDropdownRef = useRef<HTMLDivElement>(null);
  const [rentalConfirm, setRentalConfirm] = useState<{
    offerId: string;
    propertyId: string;
    propertyName: string;
    tenantSlug: string;
    tenantName: string;
  } | null>(null);
  // L10.S2 — Unconfirmed succes Callout flow (Confirmă / Ceva nu e în regulă).
  const [unconfirmedSuccesses, setUnconfirmedSuccesses] = useState<UnconfirmedSuccessEntry[]>(() => isSupply ? getUnconfirmedSuccesses(session?.email) : []);
  const [recentlyConfirmedEntries, setRecentlyConfirmedEntries] = useState<UnconfirmedSuccessEntry[]>([]);
  const [confirmRentalEntry, setConfirmRentalEntry] = useState<UnconfirmedSuccessEntry | null>(null);
  const [reportEntry, setReportEntry] = useState<UnconfirmedSuccessEntry | null>(null);
  const [supplyArchiveCount, setSupplyArchiveCount] = useState<number>(() => isSupply ? getSupplyArchiveCount(session?.email) : 0);
  // L10.S2 — Retraction confirmation
  const [retractTargetOfferId, setRetractTargetOfferId] = useState<string | null>(null);
  const [movedInOpen, setMovedInOpen] = useState(false);
  const [movedInOfferId, setMovedInOfferId] = useState<string | null>(null);
  const [reviewModal, setReviewModal] = useState<{
    open: boolean;
    tenantName?: string;
    tenantSlug?: string;
    propertyTitle?: string;
  }>({
    open: false
  });
  const [undoToast, setUndoToast] = useState<{
    visible: boolean;
    offerId: string;
    previousStatus: OfferStatus;
    newStatus: OfferStatus;
  } | null>(null);
  const [editModal, setEditModal] = useState<{
    open: boolean;
    mode: 'edit' | 'update-after-rejection';
    offerId: string | null;
  }>({
    open: false,
    mode: 'edit',
    offerId: null
  });
  useEffect(() => {
    if (undoToast?.visible) {
      const t = setTimeout(() => {
        setUndoToast(null);
      }, 5000);
      return () => clearTimeout(t);
    }
  }, [undoToast]);
  // Close property dropdown on outside click or Escape.
  useEffect(() => {
    if (!propertyDropdownOpen) return;
    const onClick = (e: MouseEvent) => {
      if (propertyDropdownRef.current && !propertyDropdownRef.current.contains(e.target as Node)) {
        setPropertyDropdownOpen(false);
      }
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setPropertyDropdownOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [propertyDropdownOpen]);
  const updateStatus = (id: string, status: OfferStatus) => {
    const app = applications.find(a => a.id === id);
    if (!app) return;
    const previousStatus = app.status;
    setApplications(prev => prev.map(a => a.id === id ? {
      ...a,
      status
    } : a));
    if (id.startsWith('offer_')) {
      updateOfferStatus(id, status);
    }
    setUndoToast({
      visible: true,
      offerId: id,
      previousStatus,
      newStatus: status
    });
  };
  const handleUndo = () => {
    if (!undoToast) return;
    setApplications(prev => prev.map(a => a.id === undoToast.offerId ? {
      ...a,
      status: undoToast.previousStatus
    } : a));
    if (undoToast.offerId.startsWith('offer_')) {
      updateOfferStatus(undoToast.offerId, undoToast.previousStatus);
    }
    setUndoToast(null);
  };
  const handleEditSuccess = () => {
    setEditModal({
      open: false,
      mode: 'edit',
      offerId: null
    });
  };
  // L8 — mark succes flow
  const handleMarkSucces = (offerId: string) => {
    setMovedInOfferId(offerId);
    setMovedInOpen(true);
  };
  const handleConfirmIzioMatch = (offerId: string) => {
    if (offerId.startsWith('offer_')) {
      markOfferAsSucces(offerId);
    }
    // Supply-side rental closure: mark the matched property as rented and
    // archive its other open offers via markPropertyAsRented.
    if (isSupply) {
      const succesOffer = applications.find(a => a.id === offerId);
      if (succesOffer) {
        const offerTitle = succesOffer.listingPreview?.title?.toLowerCase().trim();
        const matchedProperty = activeProperties.find(p => {
          const candidates = [p.title, p.listingTitle, p.name].filter(Boolean).map(s => (s as string).toLowerCase().trim());
          return offerTitle && candidates.some(c => c === offerTitle || offerTitle.includes(c) || c.includes(offerTitle));
        });
        if (matchedProperty) {
          markPropertyAsRented({
            propertyId: matchedProperty.id,
            offerId,
            tenantSlug: (succesOffer as any).toSlug || '',
            tenantName: succesOffer.counterpartyName
          });
          setActiveProperties(getActiveProperties(session?.email));
        }
      }
    }
    // Reflect in local state: succes for chosen, archived for all other live offers
    setApplications(prev => prev.map(a => {
      if (a.id === offerId) return {
        ...a,
        status: 'succes' as OfferStatus
      };
      if (a.status === 'archived' || a.status === 'succes') return a;
      return {
        ...a,
        status: 'archived' as OfferStatus
      };
    }));
    setArchiveSessions(getArchiveSessions());
    setMovedInOpen(false);
    setMovedInOfferId(null);
    // Don't auto-switch tab for supply — succes/archive aren't tabs anymore.
    if (!isSupply) setFilter('archive');
  };
  const handleConfirmExternal = () => {
    finalizeAnuntExternally();
    setMovedInOpen(false);
    setMovedInOfferId(null);
  };
  const handlePause = () => {
    setMovedInOpen(false);
    setMovedInOfferId(null);
  };
  const handleRequestExternalReview = () => {
    setMovedInOpen(false);
    setMovedInOfferId(null);
    // TODO L8 Phase 3: open RequestReviewModal mode='demand' for external
  };
  // Filter logic
  // - regular tabs ('new'|'saved'|'postponed'|'rejected') exclude succes/archived
  // - 'archive' shows archive sessions (demand) or archived offers (supply)
  // - 'succes' shows succes offers (supply only)
  const propertyFilteredApplications = (() => {
    if (!isSupply || !selectedPropertyId) return applications;
    const prop = activeProperties.find(p => p.id === selectedPropertyId);
    if (!prop) return applications;
    const propTitles = [prop.title, (prop as any).listingTitle, (prop as any).name].filter(Boolean).map(s => (s as string).toLowerCase().trim());
    return applications.filter(a => {
      const t = a.listingPreview?.title?.toLowerCase().trim();
      if (!t) return false;
      return propTitles.some(c => c === t || t.includes(c) || c.includes(t));
    });
  })();
  const filtered = filter === 'archive' ? isSupply ? propertyFilteredApplications.filter(a => a.status === 'archived').sort((a, b) => 0) : [] : filter === 'succes' ? propertyFilteredApplications.filter(a => a.status === 'succes').sort((a, b) => 0) : propertyFilteredApplications.filter(a => a.status === filter && a.status !== 'succes' && a.status !== 'archived').sort((a, b) => {
    const fa = getMatchFraction(a.matchScore);
    const fb = getMatchFraction(b.matchScore);
    if (fa !== fb) return fb - fa;
    return 0;
  });
  const succesCount = propertyFilteredApplications.filter(a => a.status === 'succes').length;
  const archivedCount = propertyFilteredApplications.filter(a => a.status === 'archived').length;
  const newCount = propertyFilteredApplications.filter(a => a.status === 'new').length;
  // Has the user actually received/sent any offers (regardless of tab)?
  const hasAnyOffers = propertyFilteredApplications.filter(a => a.status !== 'succes' && a.status !== 'archived').length > 0;
  // Per-property offer count helper for the dropdown label badges.
  const getOfferCountForProperty = (propertyId: string | null): number => {
    const baseList = propertyId === null ? applications : (() => {
      const prop = activeProperties.find(p => p.id === propertyId);
      if (!prop) return [];
      const propTitles = [prop.title, (prop as any).listingTitle, (prop as any).name].filter(Boolean).map(s => (s as string).toLowerCase().trim());
      return applications.filter(a => {
        const t = a.listingPreview?.title?.toLowerCase().trim();
        if (!t) return false;
        return propTitles.some(c => c === t || t.includes(c) || c.includes(t));
      });
    })();
    return baseList.filter(a => a.status !== 'succes' && a.status !== 'archived').length;
  };
  const selectedProperty = selectedPropertyId !== null ? activeProperties.find(p => p.id === selectedPropertyId) : null;
  const selectedPropertyLabel = selectedProperty ? selectedProperty.title || (selectedProperty as any).listingTitle || (selectedProperty as any).name || 'Proprietate fără nume' : 'Toate proprietățile';
  // L8.4 — Landlord success-moment Callout. Surface a celebration above the
  // filter tabs when any of the landlord's offers transitioned to 'succes'
  // and hasn't been acknowledged yet.
  const unseenSuccesOffers = isSupply ? applications.filter(a => a.status === 'succes' && !seenSuccesIds.includes(a.id)) : [];
  const handleDismissSuccesCallout = () => {
    if (unseenSuccesOffers.length === 0) return;
    const ids = unseenSuccesOffers.map(o => o.id);
    markSuccesSeen(ids);
    setSeenSuccesIds(prev => Array.from(new Set([...prev, ...ids])));
  };
  // L10.S2 — refresh derived supply state after a property/offer mutation.
  const refreshSupplyState = () => {
    if (!isSupply) return;
    setActiveProperties(getActiveProperties(session?.email));
    setUnconfirmedSuccesses(getUnconfirmedSuccesses(session?.email));
    setSupplyArchiveCount(getSupplyArchiveCount(session?.email));
  };
  // Confirmă închirierea — opens a ConfirmDialog scoped to this entry.
  const handleConfirmRentalOpen = (entry: UnconfirmedSuccessEntry) => {
    setConfirmRentalEntry(entry);
  };
  const handleConfirmRentalCancel = () => setConfirmRentalEntry(null);
  const handleConfirmRentalApprove = () => {
    if (!confirmRentalEntry) return;
    const {
      offer,
      property
    } = confirmRentalEntry;
    if (property) {
      markPropertyAsRented({
        propertyId: property.id,
        offerId: offer.id,
        tenantSlug: offer.toSlug,
        tenantName: offer.toName
      });
    } else if (offer.id.startsWith('offer_')) {
      // Fallback: no property in store — at least flip the offer to succes.
      markOfferAsSucces(offer.id);
    }
    // Add to recently confirmed for the post-confirmation banner (agents only)
    if (isAgent) {
      setRecentlyConfirmedEntries(prev => [...prev, confirmRentalEntry]);
    }
    // Reflect in local UI state immediately.
    setApplications(prev => prev.map(a => {
      if (a.id === offer.id) return {
        ...a,
        status: 'succes' as OfferStatus
      };
      // Sibling offers tied to the same property (or title) get archived.
      const propTitle = property ? (property.title || (property as any).name || '').toLowerCase().trim() : null;
      const aTitle = a.listingPreview?.title?.toLowerCase().trim();
      const sameProperty = property && (a as any).propertyId && (a as any).propertyId === property.id || propTitle && aTitle && (aTitle === propTitle || aTitle.includes(propTitle) || propTitle.includes(aTitle));
      if (sameProperty && a.status !== 'archived' && a.status !== 'succes' && a.id !== offer.id) {
        return {
          ...a,
          status: 'archived' as OfferStatus
        };
      }
      return a;
    }));
    setConfirmRentalEntry(null);
    refreshSupplyState();
  };
  // Ceva nu e în regulă — open report modal.
  const handleReportOpen = (entry: UnconfirmedSuccessEntry) => {
    setReportEntry(entry);
  };
  const handleReportClose = () => setReportEntry(null);
  // Retragere ofertă (supply action from OfferCard menu).
  const handleRetractRequest = (offerId: string) => {
    setRetractTargetOfferId(offerId);
  };
  const handleRetractCancel = () => setRetractTargetOfferId(null);
  const handleRetractConfirm = () => {
    if (!retractTargetOfferId) return;
    const retractedBy: 'proprietar' | 'agent' = isAgent ? 'agent' : 'proprietar';
    if (retractTargetOfferId.startsWith('offer_')) {
      retractOffer(retractTargetOfferId, retractedBy);
    }
    setApplications(prev => prev.map(a => a.id === retractTargetOfferId ? {
      ...a,
      status: 'rejected' as OfferStatus,
      rejectNote: `Retras de ${retractedBy}`
    } : a));
    setRetractTargetOfferId(null);
    refreshSupplyState();
  };
  const handleOpenReviewForTenant = (name: string) => {
    setReviewModal({
      open: true,
      tenantName: name
    });
  };
  const handleViewTenantProfile = (offer: OfferData) => {
    const slug = (offer as any).toSlug as string | undefined;
    if (!slug) return;
    navigate(PAGE_ROUTE.TENANT_PROFILE, {
      slug
    });
  };
  const title = isSupply ? 'Oferte trimise' : 'Oferte primite';
  const subtitle = isSupply ? 'Toate ofertele pe care le trimiți chiriașilor din Marketplace apar aici — vezi statusul, mesajele și răspunsurile primite.' : 'Proprietarii care au văzut profilul tău și vor să-ți facă o ofertă apar aici. Tu decizi cu cine continui conversația.';
  const activeOffer = editModal.offerId ? applications.find(a => a.id === editModal.offerId) : null;
  const getStatusLabel = (status: OfferStatus) => {
    switch (status) {
      case 'new':
        return 'Noi';
      case 'saved':
        return 'Salvate';
      case 'postponed':
        return 'Amânate';
      case 'rejected':
        return 'Respinse';
      case 'succes':
        return 'Succes';
      case 'archived':
        return 'Arhivate';
    }
  };
  // Preselected offer for MovedInModal
  const movedInPreselected = movedInOfferId ? (() => {
    const o = applications.find(a => a.id === movedInOfferId);
    if (!o) return undefined;
    return {
      id: o.id,
      counterpartyName: o.counterpartyName,
      counterpartyAvatar: o.counterpartyAvatar,
      listingTitle: o.listingPreview?.title,
      listingImage: o.listingPreview?.image,
      listingPrice: o.listingPreview?.priceLabel,
      listingLocation: o.listingPreview?.locationLabel
    };
  })() : undefined;
  const movedInAvailableOffers = applications.filter(a => a.status === 'saved').map(a => ({
    id: a.id,
    counterpartyName: a.counterpartyName,
    counterpartyAvatar: a.counterpartyAvatar,
    listingTitle: a.listingPreview?.title,
    listingPrice: a.listingPreview?.priceLabel
  }));
  return <div className="space-y-6 relative" data-id="element-3321">
      <div className="flex items-center justify-between gap-3" data-id="element-3322">
        <h1 className="text-2xl font-bold text-light-1" data-id="element-3323">{title}</h1>
        <div className="flex items-center gap-4" data-id="element-3324">
          {!isSupply && archiveSessions.length > 0 && <button type="button" onClick={() => setFilter('archive')} className="inline-flex items-center gap-1.5 text-xs text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-3325">
              <Archive size={14} weight="regular" data-id="element-3326" />
              Arhivă · {archiveSessions.length}
            </button>}
          {isSupply && supplyArchiveCount > 0 && <button type="button" onClick={() => navigate(PAGE_ROUTE.DASHBOARD_APLICARI_ARCHIVE)} className="inline-flex items-center gap-1.5 text-xs text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-3327">
              <Archive size={14} weight="regular" data-id="element-3328" />
              Arhivă · {supplyArchiveCount}
            </button>}
          <span className="text-xs text-light-3" data-id="element-3329">
            {propertyFilteredApplications.filter(a => a.status !== 'succes' && a.status !== 'archived').length}{' '}
            oferte
          </span>
        </div>
      </div>

      <p className="text-sm text-light-3 max-w-2xl" data-id="element-3330">{subtitle}</p>

      {/* L10.S2 — Rental confirmation callout. Persistent stack of one-per-property
                            successes the landlord/agent hasn't confirmed yet. Sits directly under
                            the subtitle so a closed deal is the first thing they see. */}
      {isSupply && (unconfirmedSuccesses.length > 0 || recentlyConfirmedEntries.length > 0) && <RentalConfirmationCallout entries={unconfirmedSuccesses} recentlyConfirmedEntries={recentlyConfirmedEntries} onConfirm={handleConfirmRentalOpen} onReport={handleReportOpen} onViewTenantProfile={slug => navigate(PAGE_ROUTE.TENANT_PROFILE, {
      slug
    })} isAgent={isAgent} onRequestReview={entry => setReviewModal({
      open: true,
      tenantName: entry.offer.toName,
      tenantSlug: entry.offer.toSlug,
      propertyTitle: entry.property?.title || entry.offer.listingPreview?.title
    })} onDismissRecent={offerId => setRecentlyConfirmedEntries(prev => prev.filter(e => e.offer.id !== offerId))} data-id="element-3331" />}

      {/* Filter row — property dropdown (primary, left) + status pills
                              (secondary, right). Dropdown only renders when there are 2+
                              properties to choose from. Mobile: stacks. */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" data-id="element-3332">
        {/* Property dropdown — supply only, 2+ properties */}
        {isSupply && activeProperties.length >= 2 ? <div ref={propertyDropdownRef} className="relative shrink-0" data-id="element-3333">
            <button type="button" onClick={() => setPropertyDropdownOpen(v => !v)} aria-haspopup="listbox" aria-expanded={propertyDropdownOpen} className={cn('inline-flex items-center gap-2 h-9 pl-3 pr-2.5 rounded-md', 'bg-dark-2 border border-dark-4 text-light-1 text-xs font-medium', 'hover:border-light-4 transition-colors cursor-pointer', 'outline-none focus-visible:ring-2 focus-visible:ring-lime-1', 'max-w-full')} data-id="element-3334">
              <HouseLine size={14} weight="regular" className="text-light-3 shrink-0" data-id="element-3335" />
              <span className="truncate max-w-[180px] sm:max-w-[220px]" title={selectedPropertyLabel} data-id="element-3336">
                {selectedPropertyLabel}
              </span>
              <span className="inline-flex items-center justify-center min-w-[20px] h-5 rounded-full text-[10px] font-bold px-1.5 bg-dark-3 text-light-2 shrink-0" data-id="element-3337">
                {getOfferCountForProperty(selectedPropertyId)}
              </span>
              <CaretDown size={12} weight="bold" className={cn('text-light-3 shrink-0 transition-transform', propertyDropdownOpen && 'rotate-180')} data-id="element-3338" />
            </button>

            {propertyDropdownOpen && <div role="listbox" className={cn('absolute left-0 mt-1 z-30 w-[min(320px,calc(100vw-2rem))]', 'rounded-md bg-dark-2 border border-dark-4 shadow-2xl overflow-hidden', 'animate-in fade-in slide-in-from-top-1 duration-150')} data-id="element-3339">
                <ul className="max-h-[280px] overflow-y-auto py-1" data-id="element-3340">
                  <li data-id="element-3341">
                    <button type="button" role="option" aria-selected={selectedPropertyId === null} onClick={() => {
                setSelectedPropertyId(null);
                setPropertyDropdownOpen(false);
              }} className={cn('w-full flex items-center gap-2 px-3 py-2 text-left transition-colors cursor-pointer', selectedPropertyId === null ? 'bg-dark-3 text-light-1' : 'text-light-2 hover:bg-dark-3 hover:text-light-1')} data-id="element-3342">
                      <span className="w-4 shrink-0" data-id="element-3343">
                        {selectedPropertyId === null && <Check size={14} weight="bold" className="text-lime-1" data-id="element-3344" />}
                      </span>
                      <span className="flex-1 text-xs font-medium truncate" data-id="element-3345">
                        Toate proprietățile
                      </span>
                      <span className="text-[10px] text-light-3 shrink-0" data-id="element-3346">
                        {getOfferCountForProperty(null)}
                      </span>
                    </button>
                  </li>
                  <li className="my-1 border-t border-dark-4" aria-hidden="true" data-id="element-3347" />
                  {activeProperties.map(p => {
              const label = p.title || (p as any).listingTitle || (p as any).name || 'Proprietate fără nume';
              const isSel = selectedPropertyId === p.id;
              const count = getOfferCountForProperty(p.id);
              return <li key={p.id} data-id="element-3348">
                        <button type="button" role="option" aria-selected={isSel} onClick={() => {
                  setSelectedPropertyId(p.id);
                  setPropertyDropdownOpen(false);
                }} className={cn('w-full flex items-center gap-2 px-3 py-2 text-left transition-colors cursor-pointer', isSel ? 'bg-dark-3 text-light-1' : 'text-light-2 hover:bg-dark-3 hover:text-light-1')} title={label} data-id="element-3349">
                          <span className="w-4 shrink-0" data-id="element-3350">
                            {isSel && <Check size={14} weight="bold" className="text-lime-1" data-id="element-3351" />}
                          </span>
                          <span className="flex-1 text-xs font-medium truncate" data-id="element-3352">
                            {label}
                          </span>
                          <span className="text-[10px] text-light-3 shrink-0" data-id="element-3353">
                            {count}
                          </span>
                        </button>
                      </li>;
            })}
                </ul>
              </div>}
          </div> :
      // Spacer when no dropdown — keeps pills right-aligned on desktop
      // and avoids a layout shift when properties get added.
      <span aria-hidden="true" className="hidden sm:block" data-id="element-3354" />}

        {/* Status pills — same row, right-aligned on desktop */}
        <div className="flex flex-wrap items-center gap-2 sm:justify-end" data-id="element-3355">
          {FILTER_OPTIONS.map(status => {
          const filterIcon = status.value === 'new' ? <MailIcon size={14} weight="regular" data-id="element-3356" /> : status.value === 'saved' ? <Heart size={14} weight="regular" data-id="element-3357" /> : status.value === 'postponed' ? <Clock size={14} weight="regular" data-id="element-3358" /> : status.value === 'rejected' ? <XCircle size={14} weight="regular" data-id="element-3359" /> : null;
          return <button key={status.value} onClick={() => setFilter(status.value)} className={cn('px-4 py-2 rounded-full text-xs font-medium transition-colors cursor-pointer border flex items-center gap-2', filter === status.value ? 'bg-lime-1 text-dark-1 border-lime-1' : 'bg-dark-3 text-light-2 border-dark-4 hover:border-light-4')} data-id="element-3360">
                {filterIcon}
                {status.label}
                {status.value === 'new' && newCount > 0 && <span className={cn('flex items-center justify-center min-w-[20px] h-5 rounded-full text-[10px] font-bold px-1.5', filter === status.value ? 'bg-dark-1 text-lime-1' : 'bg-lime-1 text-dark-1')} data-id="element-3361">
                    {newCount}
                  </span>}
              </button>;
        })}
        </div>
      </div>

      {/* Archive sessions view (demand only) — entered via header link. */}
      {filter === 'archive' && !isSupply && <>
          <button type="button" onClick={() => setFilter('new')} className="inline-flex items-center gap-1.5 text-xs text-light-3 hover:text-light-1 transition-colors cursor-pointer" data-id="element-3362">
            ← Înapoi la oferte active
          </button>
          {archiveSessions.length === 0 ? <div className="rounded-2xl bg-dark-2 border border-dark-3 p-10 sm:p-14 text-center mt-8" data-id="element-3363">
              <div className="w-14 h-14 rounded-2xl bg-dark-3 flex items-center justify-center mx-auto mb-5" data-id="element-3364">
                <Archive size={28} weight="duotone" className="text-light-2" data-id="element-3365" />
              </div>
              <h3 className="text-lg font-semibold text-light-1 mb-2" data-id="element-3366">
                Nicio sesiune închisă încă
              </h3>
              <p className="text-sm text-light-3 leading-relaxed max-w-md mx-auto" data-id="element-3367">
                Aici vei vedea istoricul căutărilor tale. Când marchezi o ofertă
                ca succes, sesiunea curentă se arhivează automat.
              </p>
            </div> : <div className="space-y-3" data-id="element-3368">
              {archiveSessions.map(s => {
          const succesOffer = s.succesOfferId ? applications.find(a => a.id === s.succesOfferId) : undefined;
          return <ArchiveSessionCard key={s.id} session={s} offerCount={s.offerIds.length} succesCounterpartyName={succesOffer?.counterpartyName} data-id="element-3369" />;
        })}
            </div>}
        </>}

      {/* Applications list — per-tab empty states. */}
      {!(filter === 'archive' && !isSupply) && (filtered.length === 0 ? <div className="rounded-2xl bg-dark-2 border border-dark-3 p-10 sm:p-14 text-center mt-8" data-id="element-3370">
            <div className="w-14 h-14 rounded-2xl bg-dark-3 flex items-center justify-center mx-auto mb-5" data-id="element-3371">
              {isSupply ? <PaperPlaneTilt size={28} weight="duotone" className="text-light-2" data-id="element-3372" /> : <MailIcon size={28} weight="duotone" className="text-light-2" data-id="element-3373" />}
            </div>
            {hasAnyOffers ?
      // Per-tab empty: user has offers, just none matching the active filter.
      <>
                <h3 className="text-lg font-semibold text-light-1 mb-2" data-id="element-3374">
                  {filter === 'new' && 'Nicio ofertă nouă'}
                  {filter === 'saved' && 'Nicio ofertă salvată'}
                  {filter === 'postponed' && 'Nicio ofertă amânată'}
                  {filter === 'rejected' && 'Nicio ofertă respinsă'}
                </h3>
                <p className="text-sm text-light-3 leading-relaxed max-w-md mx-auto" data-id="element-3375">
                  {filter === 'new' && (isSupply ? 'Toate ofertele tale au primit deja un răspuns. Trimite altele din Marketplace.' : 'Ai răspuns la toate ofertele. Verifică tabul Salvate sau Amânate.')}
                  {filter === 'saved' && 'Ofertele pe care le marchezi cu interes apar aici.'}
                  {filter === 'postponed' && 'Ofertele pe care le pui în așteptare apar aici.'}
                  {filter === 'rejected' && 'Ofertele pe care le refuzi apar aici.'}
                </p>
              </> :
      // Global empty: no offers at all (filtered by selected property).
      <>
                <h3 className="text-lg font-semibold text-light-1 mb-2" data-id="element-3376">
                  {isSupply ? selectedPropertyId ? 'Nicio ofertă pentru această proprietate' : 'Nu ai trimis nicio ofertă încă' : 'Nicio ofertă încă'}
                </h3>
                <p className="text-sm text-light-3 leading-relaxed max-w-md mx-auto mb-6" data-id="element-3377">
                  {isSupply ? selectedPropertyId ? 'Răsfoiește Marketplace-ul și trimite oferte personalizate chiriașilor care caută o proprietate ca a ta.' : 'Răsfoiește Marketplace-ul, găsește un chiriaș potrivit și trimite o ofertă personalizată direct din profilul lui.' : 'Când un proprietar îți va trimite o ofertă, o vei vedea aici. Asigură-te că anunțul tău este public!'}
                </p>
                {isSupply && <Button onClick={() => navigate(PAGE_ROUTE.MARKETPLACE)} className="bg-lime-1 hover:bg-lime-2 text-dark-1 font-semibold h-11 px-6" data-id="element-3378">
                    <MagnifyingGlass size={18} weight="bold" className="mr-2" data-id="element-3379" />
                    Explorează Marketplace
                  </Button>}
              </>}
          </div> : <div className="space-y-4" data-id="element-3380">
            {filtered.map(app => <OfferCard key={app.id} offer={app} viewerRole={isSupply ? 'sender' : 'receiver'} tenantName={tenantName} onAccept={() => updateStatus(app.id, 'saved')} onPostpone={() => updateStatus(app.id, 'postponed')} onReject={() => updateStatus(app.id, 'rejected')} onStatusChange={newStatus => updateStatus(app.id, newStatus)} onMarkSucces={() => handleMarkSucces(app.id)} onViewSupplyProfile={isSupply ? undefined : (() => {
        const slug = supplySlugFromEmail(app.contactEmail);
        return slug ? () => navigate(PAGE_ROUTE.LANDLORD_PROFILE, {
          slug
        }) : undefined;
      })()} onEdit={() => setEditModal({
        open: true,
        mode: 'edit',
        offerId: app.id
      })} onUpdateAfterRejection={() => setEditModal({
        open: true,
        mode: 'update-after-rejection',
        offerId: app.id
      })} onViewTenantAnunt={isSupply ? () => navigate(PAGE_ROUTE.TENANT_ANUNT, {
        tenantId: app.id,
        tenantName: app.counterpartyName
      }) : undefined} data-id="element-3381" />)}
          </div>)}

      {/* Undo Toast */}
      {undoToast?.visible && <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 animate-in slide-in-from-bottom-5 fade-in duration-300" data-id="element-3382">
          <div className="bg-dark-1 border border-dark-3 rounded-md shadow-2xl px-4 py-2.5 flex items-center gap-4" data-id="element-3383">
            <span className="text-sm text-light-2" data-id="element-3384">
              Mutat în{' '}
              <span className="font-medium text-light-1" data-id="element-3385">
                {getStatusLabel(undoToast.newStatus)}
              </span>
            </span>
            <div className="w-px h-4 bg-dark-4" data-id="element-3386" />
            <button onClick={handleUndo} className="text-sm font-medium text-lime-1 hover:text-lime-2 transition-colors" data-id="element-3387">
              Anulează
            </button>
          </div>
        </div>}

      {/* Edit Modal */}
      {activeOffer && <OfferEditModal isOpen={editModal.open} onClose={() => setEditModal({
      open: false,
      mode: 'edit',
      offerId: null
    })} mode={editModal.mode} tenantName={activeOffer.counterpartyName} tenantProfileId="mock-id" onSuccess={handleEditSuccess} navigate={navigate} data-id="element-3388" />}

      {/* L8 — Moved-in modal */}
      <MovedInModal isOpen={movedInOpen} onClose={() => {
      setMovedInOpen(false);
      setMovedInOfferId(null);
    }} mode="from-offer" preselectedOffer={movedInPreselected} availableOffers={movedInAvailableOffers} onConfirmIzioMatch={handleConfirmIzioMatch} onConfirmExternal={handleConfirmExternal} onPause={handlePause} onRequestExternalReview={handleRequestExternalReview} data-id="element-3389" />

      {/* L9 — Request review modal (opened from success Callout for agents) */}
      {isSupply && <RequestReviewModal open={reviewModal.open} mode="supply" navigate={navigate} preselectedTenantName={reviewModal.tenantName} preselectedTenantSlug={reviewModal.tenantSlug} preselectedPropertyTitle={reviewModal.propertyTitle} onClose={() => setReviewModal({
      open: false
    })} onSuccess={() => {
      setReviewModal({
        open: false
      });
    }} data-id="element-3390" />}

      {/* L10.S2 — Confirm rental dialog (from RentalConfirmationCallout) */}
      <ConfirmDialog open={!!confirmRentalEntry} title="Confirmă închirierea" description={confirmRentalEntry ? `Marchezi această închiriere ca finalizată cu ${confirmRentalEntry.offer.toName}. Toate celelalte oferte pentru această proprietate vor fi arhivate automat.` : undefined} confirmLabel="Confirmă închirierea" cancelLabel="Anulează" dashboardOffset onConfirm={handleConfirmRentalApprove} onCancel={handleConfirmRentalCancel} data-id="element-3391" />

      {/* L10.S2 — Report rental issue modal ("Ceva nu e în regulă") */}
      <ReportRentalIssueModal isOpen={!!reportEntry} onClose={handleReportClose} offerId={reportEntry?.offer.id || ''} tenantName={reportEntry?.offer.toName} propertyTitle={reportEntry?.property?.title || (reportEntry?.property as any)?.name || reportEntry?.offer.listingPreview?.title} onSubmitted={handleReportClose} data-id="element-3392" />

      {/* L10.S2 — Retract offer confirmation */}
      <ConfirmDialog open={!!retractTargetOfferId} title="Retragi această ofertă?" description="Oferta va fi marcată ca respinsă cu nota 'Retras de proprietar/agent'. Chiriașul nu va mai putea acționa pe ea." confirmLabel="Retrage oferta" cancelLabel="Anulează" variant="danger" dashboardOffset onConfirm={handleRetractConfirm} onCancel={handleRetractCancel} data-id="element-3393" />
    </div>;
}